import useFirestoreCollection from '../hooks/useFirestoreCollection';
import StoreCashSlider from '../containers/StoreCashSlider';
import Spinner from '../UI/Spinner';
import FirebaseData from './FirebaseData';
import Subtext from '../components/SubText';

const Results = () => {
  const sku = window.WCParamJS.partNumber.replace('P_', '');
  const { data, loading, error } = useFirestoreCollection('products', sku);
  const {
    widgetRewards,
    widgetModals,
    siteWideRewardsObject,
    headerText,
    subText,
    rewardNames,
    firebaseerror,
    firebaseloading,
  } = FirebaseData();

  //console.log('data from the product feed 1:', data);
  
  if (data) {
    const productIsExcluded =
    data.offers &&
    data.offers.some((offer) => offer.type === 'StoreCash Excluded Product');

    const rewardsList =
      data.offers && data.offers.map((reward) => reward.customFieldvalue1);

    const rewardsListAndValues =
      data.offers &&
      data.offers.flatMap((reward) => [
        reward.customFieldvalue1,
        reward.customFieldvalue2,
        reward.endDate,
      ]);

      function splitArrayIntoSubarrays(arr, subarraySize) {
        const subarrays = [];
        for (let i = 0; i < arr.length; i += subarraySize) {
          subarrays.push(arr.slice(i, i + subarraySize));
        }
        return subarrays;
      }
      const rewardsArray = data.offers && splitArrayIntoSubarrays(rewardsListAndValues, 3);
      //console.log('rewardsArray',rewardsArray)

    const isNotEligible = data.productRange === 'PF' || productIsExcluded;
    const isNotEligible_message = (
      <p className="text-size-110 text-bold line-height-sm">
       90 Day StoreCash<sup>></sup> cannot be earned or redeemed on this product.
      </p>
    )

    const heading = data.heading;
    const skuModel = data.model;
    const rewardsForSku =
      data.offers &&
      rewardsList.filter((element) => rewardNames.includes(element));

//console.log('rewardsForSku:',rewardsForSku)

    const filteredData = {};
    if (data.offers) {
      rewardsArray.forEach(d => {
        const key1 = d[0];
        const value1 = d[1];
        const reward_endDate1 = d[2]
        
        if (rewardsForSku.includes(key1)) {
          filteredData[key1] = {
            ...(widgetRewards[key1] || {}),
            amount: value1,
            heading: heading,
            reward_endDate: reward_endDate1,
            skuModel: skuModel,
          };
        }
      })
    }
    const combinedRewards = { ...filteredData, ...siteWideRewardsObject };
    for (const key in combinedRewards) {
      if (!combinedRewards[key].amount) {
        combinedRewards[key].amount = 0;
      }
      if (!combinedRewards[key].reward_endDate) {
        combinedRewards[key].reward_endDate = 'not given';
      }
    }
    //console.log('combinedRewards',combinedRewards)

    if (loading || firebaseloading) {
      return <Spinner />;
    }
    if (error || firebaseerror) {
      return <p>Error: {error.message}</p>;
    }

    const showWidget = data.offers && Object.values(combinedRewards).length > 0;

    return isNotEligible ? (
      isNotEligible_message
    ) : showWidget ? (
      <>
        <div
          className="text-bold text-size-110 marg-bottm-10"
          dangerouslySetInnerHTML={{ __html: headerText }}
        />
        <StoreCashSlider tilesData={combinedRewards} />
        <Subtext text={subText} widgetModals={widgetModals} />
      </>
    ) : null;
  }

  return null;
};

export default Results;
